




































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IProgram, ICourse, SearchType } from '../Scripts/ISearchService';
import { faChevronDown, faChevronUp, faHeart, faTimes, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { VBPopover } from 'bootstrap-vue';

import ResultDetailCourse from './ResultDetailCourse.vue';
import ResultDetailProgram from './ResultDetailProgram.vue';

import ActionTracker, {
	TransitionEvent, ExpandEvent, CollapseEvent, OpenRmiEvent, AddFavoriteEvent
} from '../Scripts/AnalyticsEvents';
import { msiInfo } from '../Scripts/MsiInfo';

@Component({
	components: {
		ResultDetailCourse, ResultDetailProgram
	},
	directives: {
		'b-popover': VBPopover
	}
})
export default class ResultPanel extends Vue {
	@Prop() public item!: IProgram | ICourse;
	@Prop() public interactive!: boolean;
	@Prop() public searchType!: SearchType;

	public expanded = false;

	public toogleExpand (): void {
		if (this.expanded) {
			ActionTracker.track(new CollapseEvent(this.item, this.$router));
		} else {
			ActionTracker.track(new ExpandEvent(this.item));
		}

		this.expanded = !this.expanded;
	}

	// same code appears in search summary
	get entityName (): string {
		switch (this.searchType) {
			case SearchType.Course: return 'Course';
			case SearchType.Program: return 'Program';
			default: return 'Unknown Type';
		}
	}

	get detailComponent (): string {
		switch (this.searchType) {
			case SearchType.Course: return 'resultDetailCourse';
			case SearchType.Program: return 'resultDetailProgram';
			default: return 'unknown';
		}
	}

	get showDetail (): boolean {
		return this.expanded || !this.interactive;
	}

	get expandIcon (): IconDefinition {
		return this.expanded ? faChevronUp : faChevronDown;
	}

	get expandText (): string {
		return this.expanded ? 'Show Less' : 'Show More';
	}

	get sanitizedDescription (): string {
		// poor man's sanitization
		const desc = this.item.description
			.replace(/&/g, '&amp;')
			.replace(/</g, '&#60;')
			.replace(/>/g, '&#62;')
			.replace(/'/g, '&#x27;')
			.replace(/"/g, '&quot;')
			.replace(/\//g, '&#x2F;');

		// honor CR
		return desc.replace(/(\r\n|\n|\r)/g, '<br>');
	}

	public toogleFav (): void {
		if (this.favorited) {
			this.$store.commit('removeFavorite', this.item);
		} else {
			this.$store.commit('addFavorite', this.item);
			ActionTracker.track(new AddFavoriteEvent(this.item));
		}
	}

	get favorites (): IProgram[] | ICourse[] {
		switch (this.searchType) {
			case SearchType.Course: return this.$store.state.courseFavorites;
			case SearchType.Program: return this.$store.state.favorites;
			default: return [];
		}
	}

	get favorited (): boolean {
		return this.favorites.some((p: IProgram | ICourse) => p.id === this.item.id);
	}

	get favIcon (): IconDefinition {
		return this.favorited ? faTimes : faHeart;
	}

	get favText (): string {
		return this.favorited ? 'Remove Favorite' : 'Add to Favorites';
	}

	public requestMoreInfo (item: IProgram | ICourse): void {
		ActionTracker.track(new OpenRmiEvent(this.item));
		this.$emit('request-more-info', item);
	}

	public msiClassifications (item: IProgram | ICourse): string {
		if (!item.msiCodes) return '';

		return item.msiCodes.map(c => msiInfo.getMetadata(c).title).join(', ');
	}

	private visit (item: IProgram | ICourse): void {
		ActionTracker.track(new TransitionEvent(item));
	}
}
